export const CRM_SEARCH_GRAPHQL_CACHE_KEY = 'crmObjectsSearch';
